import type { SVGProps } from 'react';

const SvgConditionalSplit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M28.72.77H3.28A2.75 2.75 0 0 0 .53 3.52v11a2.75 2.75 0 0 0 2.75 2.75h10.23v-1.5H3.28A1.25 1.25 0 0 1 2 14.5v-11a1.25 1.25 0 0 1 1.28-1.23h12v17.49a7.1 7.1 0 0 1-7.09 7.09h-.12v-.27a2.76 2.76 0 0 0-2.75-2.75h-2a2.76 2.76 0 0 0-2.79 2.75v2a2.76 2.76 0 0 0 2.75 2.75h2a2.76 2.76 0 0 0 2.75-2.75v-.27h.09A8.6 8.6 0 0 0 16 23.25a8.6 8.6 0 0 0 7.44 5.08v.29a2.75 2.75 0 0 0 2.75 2.75h2A2.76 2.76 0 0 0 31 28.62v-2a2.76 2.76 0 0 0-2.75-2.75h-2a2.75 2.75 0 0 0-2.75 2.75v.25a7.1 7.1 0 0 1-6.69-7.07V2.27h12A1.25 1.25 0 0 1 30 3.52v11a1.25 1.25 0 0 1-1.25 1.25H18.6v1.5h10.12a2.75 2.75 0 0 0 2.75-2.75v-11A2.75 2.75 0 0 0 28.72.77ZM6.57 28.62a1.26 1.26 0 0 1-1.25 1.25h-2A1.26 1.26 0 0 1 2 28.62v-2a1.25 1.25 0 0 1 1.25-1.25h2a1.26 1.26 0 0 1 1.25 1.25Zm18.37-2a1.25 1.25 0 0 1 1.25-1.25h2a1.25 1.25 0 0 1 1.25 1.25v2a1.26 1.26 0 0 1-1.25 1.25h-2a1.26 1.26 0 0 1-1.25-1.25Z"
      data-name="conditional-split"
    />
  </svg>
);

export default SvgConditionalSplit;
